var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
var GeometryReshapingTool = /** @class */ (function (_super) {
    __extends(GeometryReshapingTool, _super);
    function GeometryReshapingTool() {
        var _this = _super.call(this) || this;
        _this.angle = 0;
        _this.length = 0;
        _this._reshapeObjectName = 'SHAPE';
        _this._handle = null;
        _this._adornedShape = null;
        _this._originalGeometry = null; // in case the tool is cancelled and the UndoManager is not enabled
        var h = new go.Shape();
        h.figure = 'Diamond';
        h.desiredSize = new go.Size(10, 10);
        h.fill = '#fff935';
        h.stroke = 'gray';
        h.cursor = 'move';
        _this._handleArchetype = h;
        _this.name = 'LineReshaping';
        _this.prevStrokeWidth = 1;
        return _this;
    }
    Object.defineProperty(GeometryReshapingTool.prototype, "handleArchetype", {
        get: function () { return this._handleArchetype; },
        set: function (value) { this._handleArchetype = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryReshapingTool.prototype, "reshapeObjectName", {
        get: function () { return this._reshapeObjectName; },
        set: function (value) { this._reshapeObjectName = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryReshapingTool.prototype, "handle", {
        get: function () { return this._handle; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryReshapingTool.prototype, "adornedShape", {
        get: function () { return this._adornedShape; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeometryReshapingTool.prototype, "originalGeometry", {
        get: function () { return this._originalGeometry; },
        enumerable: true,
        configurable: true
    });
    GeometryReshapingTool.prototype.updateAdornments = function (part) {
        if (part === null || part instanceof go.Link) {
            return;
        } // this tool never applies to Links
        if (part.isSelected && !this.diagram.isReadOnly) {
            var selelt = part.findObject(this.reshapeObjectName);
            var collapsibleA = part.category === DiagramConsts.elements.polyLineKey
                || part.category === DiagramConsts.elements.pipeKey || part.category === DiagramConsts.elements.polygonKey;
            var undo = false;
            if (collapsibleA) {
                undo = selelt.diagram.undoManager.isUndoingRedoing;
            }
            if (selelt instanceof go.Shape && selelt.actualBounds.isReal() && selelt.isVisibleObject() &&
                part.canReshape() && part.actualBounds.isReal() && part.isVisible() &&
                selelt.geometry.type === go.Geometry.Path) {
                var adornment = part.findAdornment(this.name);
                if (adornment === null && !selelt.panel.data.locked) {
                    adornment = this.makeAdornment(selelt);
                }
                if (adornment !== null) {
                    // update the position/alignment of each handle
                    var geo_1 = selelt.geometry;
                    var b_1 = geo_1.bounds;
                    var collapsibleB = selelt.part.category === DiagramConsts.elements.polyLineKey || selelt.part.category === DiagramConsts.elements.pipeKey
                        || part.category === DiagramConsts.elements.polygonKey;
                    if (collapsibleB && this.handle && this.handle.lastTyp === 4) {
                        adornment = this.makeAdornment(selelt);
                    }
                    if ((selelt.panel.data.locked || selelt.panel.data.locked === false) && !this.diagram.lastInput.shift) {
                        adornment = this.makeAdornment(selelt);
                    }
                    if (undo && collapsibleB) {
                        adornment = this.makeAdornment(selelt);
                    }
                    if (this.prevStrokeWidth !== selelt.strokeWidth) {
                        adornment = this.makeAdornment(selelt);
                        this.prevStrokeWidth = selelt.strokeWidth;
                    }
                    // update the size of the adornment
                    adornment.findObject('BODY').desiredSize = b_1.size;
                    adornment.elements.each(function (h) {
                        if (h._typ === undefined) {
                            return;
                        }
                        var fig = geo_1.figures.elt(h._fig);
                        var seg = fig.segments.elt(h._seg);
                        var x = 0;
                        var y = 0;
                        switch (h._typ) {
                            case 0:
                                x = fig.startX;
                                y = fig.startY;
                                break;
                            case 1:
                                x = seg.endX;
                                y = seg.endY;
                                break;
                            case 2:
                                x = seg.point1X;
                                y = seg.point1Y;
                                break;
                            case 3:
                                x = seg.point2X;
                                y = seg.point2Y;
                                break;
                            case 4:
                                if (h.prev < 0) {
                                    x = (fig.segments.elt(h.next).endX + fig.startX) / 2;
                                    y = (fig.segments.elt(h.next).endY + fig.startY) / 2;
                                }
                                else if (h.prev === fig.segments.count - 1) {
                                    x = (fig.segments.elt(h.prev).endX + fig.startX) / 2;
                                    y = (fig.segments.elt(h.prev).endY + fig.startY) / 2;
                                }
                                else {
                                    x = (fig.segments.elt(h.next).endX + fig.segments.elt(h.prev).endX) / 2;
                                    y = (fig.segments.elt(h.next).endY + fig.segments.elt(h.prev).endY) / 2;
                                }
                                break;
                        }
                        var bw = b_1.width;
                        if (bw === 0) {
                            bw = 0.001;
                        }
                        var bh = b_1.height;
                        if (bh === 0) {
                            bh = 0.001;
                        }
                        h.alignment = new go.Spot(Math.max(0, Math.min((x - b_1.x) / bw, 1)), Math.max(0, Math.min((y - b_1.y) / bh, 1)));
                    });
                    part.addAdornment(this.name, adornment);
                    adornment.location = selelt.getDocumentPoint(go.Spot.TopLeft);
                    adornment.angle = selelt.getDocumentAngle();
                    return;
                }
            }
        }
        part.removeAdornment(this.name);
    };
    GeometryReshapingTool.prototype.makeAdornment = function (selelt) {
        var adornment = new go.Adornment();
        adornment.type = go.Panel.Spot;
        adornment.locationObjectName = 'BODY';
        adornment.locationSpot = new go.Spot(0, 0, -selelt.strokeWidth / 2, -selelt.strokeWidth / 2);
        var h = new go.Shape();
        h.name = 'BODY';
        h.fill = null;
        h.stroke = null;
        h.strokeWidth = 0;
        adornment.add(h);
        var geo = selelt.geometry;
        // requires Path Geometry, checked above in updateAdornments
        if (!selelt.panel.data.locked) {
            for (var f = 0; f < geo.figures.count; f++) {
                var fig = geo.figures.elt(f);
                for (var g = 0; g < fig.segments.count; g++) {
                    var seg = fig.segments.elt(g);
                    var h_1 = void 0;
                    if (g === 0) {
                        h_1 = this.makeHandle();
                        if (h_1 !== null) {
                            h_1._typ = 0;
                            h_1._fig = f;
                            h_1._seg = g;
                            h_1.lastTyp = 1;
                            adornment.add(h_1);
                        }
                    }
                    h_1 = this.makeHandle();
                    if (h_1 !== null) {
                        h_1._typ = 1;
                        h_1._fig = f;
                        h_1._seg = g;
                        h_1.lastTyp = 1;
                        adornment.add(h_1);
                    }
                    if (seg.type === go.PathSegment.QuadraticBezier || seg.type === go.PathSegment.Bezier) {
                        h_1 = this.makeHandle();
                        if (h_1 !== null) {
                            h_1._typ = 2;
                            h_1._fig = f;
                            h_1._seg = g;
                            adornment.add(h_1);
                        }
                        if (seg.type === go.PathSegment.Bezier) {
                            h_1 = this.makeHandle();
                            if (h_1 !== null) {
                                h_1._typ = 3;
                                h_1._fig = f;
                                h_1._seg = g;
                                adornment.add(h_1);
                            }
                        }
                    }
                }
            }
            for (var f = 0; f < geo.figures.count; f++) {
                var fig = geo.figures.elt(f);
                if (selelt.part.category === DiagramConsts.elements.polyLineKey || selelt.part.category === DiagramConsts.elements.pipeKey
                    || selelt.part.category === DiagramConsts.elements.polygonKey) {
                    for (var g = 0; g < fig.segments.count; g++) {
                        var h_2 = void 0;
                        h_2 = this.makeHandle();
                        if (h_2 !== null) {
                            h_2._typ = 4;
                            h_2.figure = 'Ellipse';
                            h_2.desiredSize = new go.Size(8, 8);
                            h_2._fig = f;
                            h_2._seg = g;
                            h_2.next = g;
                            h_2.prev = g - 1;
                            h_2.lastTyp = 4;
                            adornment.add(h_2);
                        }
                    }
                }
                if (selelt.part.category === DiagramConsts.elements.polygonKey) {
                    var h_3 = void 0;
                    h_3 = this.makeHandle();
                    if (h_3 !== null) {
                        h_3._typ = 4;
                        h_3.figure = 'Ellipse';
                        h_3.desiredSize = new go.Size(8, 8);
                        h_3._fig = f;
                        h_3._seg = fig.segments.count - 1;
                        h_3.next = fig.segments.count;
                        h_3.prev = fig.segments.count - 1;
                        h_3.lastTyp = 4;
                        adornment.add(h_3);
                    }
                }
            }
        }
        adornment.category = this.name;
        adornment.adornedObject = selelt;
        return adornment;
    };
    GeometryReshapingTool.prototype.makeHandle = function () {
        var h = this.handleArchetype;
        if (h === null) {
            return null;
        }
        return h.copy();
    };
    GeometryReshapingTool.prototype.canStart = function () {
        if (!this.isEnabled) {
            return false;
        }
        var diagram = this.diagram;
        if (diagram === null || diagram.isReadOnly) {
            return false;
        }
        if (!diagram.allowReshape) {
            return false;
        }
        if (!diagram.lastInput.left) {
            return false;
        }
        var h = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        return (h !== null);
    };
    GeometryReshapingTool.prototype.doActivate = function () {
        var diagram = this.diagram;
        if (diagram === null) {
            return;
        }
        this._handle = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        if (this._handle === null) {
            return;
        }
        var shape = this.handle.part.adornedObject;
        if (!shape) {
            return;
        }
        this._adornedShape = shape;
        diagram.isMouseCaptured = true;
        this.startTransaction(this.name);
        this._originalGeometry = shape.geometry;
        this.oldSize = shape.desiredSize;
        this.isActive = true;
    };
    GeometryReshapingTool.prototype.doDeactivate = function () {
        this.stopTransaction();
        this._handle = null;
        this._adornedShape = null;
        var diagram = this.diagram;
        if (diagram !== null) {
            diagram.isMouseCaptured = false;
        }
        this.isActive = false;
    };
    GeometryReshapingTool.prototype.doCancel = function () {
        var shape = this._adornedShape;
        if (shape !== null) {
            // explicitly restore the original route, in case !UndoManager.isEnabled
            shape.geometry = this._originalGeometry;
            shape.desiredSize = this.oldSize;
        }
        this.stopTool();
    };
    GeometryReshapingTool.prototype.doMouseMove = function () {
        var diagram = this.diagram;
        if (this.isActive && diagram !== null) {
            if ((this.isStraightLine() || this.collapsible()) && this.handle._typ !== 4) {
                var mousePt = diagram.lastInput.documentPoint;
                this.calcAngleAndLengthFromHandle(mousePt); // sets this.angle and this.length (useful for when SHIFT is held)
            }
            var newpt = this.computeReshape(diagram.lastInput.documentPoint);
            this.reshape(newpt);
        }
    };
    GeometryReshapingTool.prototype.doMouseUp = function () {
        var diagram = this.diagram;
        if (this.isActive && diagram !== null) {
            var newpt = this.computeReshape(diagram.lastInput.documentPoint);
            this.reshape(newpt);
            this.transactionResult = this.name; // success
        }
        this.stopTool();
    };
    GeometryReshapingTool.prototype.reshape = function (newPoint) {
        var shape = this.adornedShape;
        if ((this.isStraightLine() || this.collapsible()) && this.diagram.lastInput.shift && this.handle._typ !== 4) {
            newPoint = this.shiftPoint();
        }
        var locpt = shape.getLocalPoint(newPoint);
        var geo = shape.geometry.copy();
        var type = this.handle._typ;
        if (type === undefined) {
            return;
        }
        var fig = geo.figures.elt(this.handle._fig);
        var seg = fig.segments.elt(this.handle._seg);
        switch (type) {
            case 0:
                fig.startX = locpt.x;
                fig.startY = locpt.y;
                if (shape.part.category === DiagramConsts.elements.polygonKey) {
                    this.setLastType(this.handle, type);
                    if (this.isBackToLine(this.handle._seg, type) && this.diagram.lastInput.up && fig.segments.count > 2) {
                        fig.startX = fig.segments.elt(0).endX;
                        fig.startY = fig.segments.elt(0).endY;
                        fig.segments.removeAt(this.handle._seg);
                    }
                }
                break;
            case 1:
                seg.endX = locpt.x;
                seg.endY = locpt.y;
                if (fig.segments.count > 1 && !(shape.part.category === DiagramConsts.elements.polygonKey)) {
                    this.setLastType(this.handle, type);
                    if (this.isBackToLine(this.handle._seg, type) && this.diagram.lastInput.up) {
                        fig.segments.removeAt(this.handle._seg);
                    }
                }
                else if (shape.part.category === DiagramConsts.elements.polygonKey) {
                    this.setLastType(this.handle, type);
                    if (this.isBackToLine(this.handle._seg, type) && this.diagram.lastInput.up && fig.segments.count > 2) {
                        fig.segments.removeAt(this.handle._seg);
                    }
                }
                break;
            case 2:
                seg.point1X = locpt.x;
                seg.point1Y = locpt.y;
                break;
            case 3:
                seg.point2X = locpt.x;
                seg.point2Y = locpt.y;
                break;
            case 4:
                var newSeg = seg.copy();
                newSeg.endX = locpt.x;
                newSeg.endY = locpt.y;
                this.handle._typ = 1;
                if (this.handle.prev === fig.segments.count - 1) {
                    fig.segments.add(newSeg);
                    this.handle._seg = this.handle.next;
                }
                else {
                    fig.segments.insertAt(this.handle.next, newSeg);
                }
                break;
        }
        var offset = geo.normalize(); // avoid any negative coordinates in the geometry
        shape.geometry = geo; // modify the Shape
        if (shape.part.category === DiagramConsts.elements.polygonKey) {
            shape.geometryString = shape.geometryString.replace('z', ' ') + 'z';
        }
        var part = shape.part; // move the Part holding the Shape
        if (!part.locationSpot.equals(go.Spot.Center)) { // but only if the locationSpot isn't Center
            part.move(part.position.copy().subtract(offset));
        }
        this.updateAdornments(part); // update any Adornments of the Part
        // this.diagram.maybeUpdate();  // force more frequent drawing for smoother looking behavior
        shape.desiredSize = new go.Size(shape.naturalBounds.width, shape.naturalBounds.height);
    };
    GeometryReshapingTool.prototype.calcDistance = function (x1, y1, x2, y2) {
        var diff_X = Math.abs(x2 - x1);
        var diff_Y = Math.abs(y2 - y1);
        var distance = Math.sqrt(Math.pow(diff_X, 2) + Math.pow(diff_Y, 2));
        return distance;
    };
    GeometryReshapingTool.prototype.setLastType = function (h, type) {
        if (!this.isBackToLine(h._seg, type)) {
            h.lastTyp = 1;
        }
        else if (this.isBackToLine(h._seg, type) && this.diagram.lastInput.up) {
            h.lastTyp = 4;
        }
        else {
            h.lastTyp = null;
        }
    };
    GeometryReshapingTool.prototype.isBackToLine = function (segNumber, type) {
        var shape = this.adornedShape;
        var geo = shape.geometry.copy();
        var fig = geo.figures.elt(this.handle._fig);
        var seg = fig.segments.elt(this.handle._seg);
        if (type === 1) {
            if (segNumber === 0) {
                var nextSeg = fig.segments.elt(this.handle._seg + 1);
                return this.canDropAdornment(seg.endX, seg.endY, fig.startX, fig.startY, nextSeg.endX, nextSeg.endY);
            }
            else if (segNumber === fig.segments.count - 1) {
                var prevSeg = fig.segments.elt(this.handle._seg - 1);
                return this.canDropAdornment(seg.endX, seg.endY, prevSeg.endX, prevSeg.endY, fig.startX, fig.startY);
            }
            else {
                var nextSeg = fig.segments.elt(this.handle._seg + 1);
                var prevSeg = fig.segments.elt(this.handle._seg - 1);
                return this.canDropAdornment(seg.endX, seg.endY, prevSeg.endX, prevSeg.endY, nextSeg.endX, nextSeg.endY);
            }
        }
        else if (type === 0) {
            var prevSeg = fig.segments.elt(fig.segments.count - 1);
            var nextSeg = fig.segments.elt(0);
            return this.canDropAdornment(fig.startX, fig.startY, prevSeg.endX, prevSeg.endY, nextSeg.endX, nextSeg.endY);
        }
    };
    GeometryReshapingTool.prototype.canDropAdornment = function (ItselfX, ItselfY, prevX, prevY, nextX, nextY) {
        var ItselfToPrevSegScale = this.calcDistance(prevX, prevY, ItselfX, ItselfY);
        var ItselfToNextSegScale = this.calcDistance(nextX, nextY, ItselfX, ItselfY);
        var nextSegToPrevSegScale = this.calcDistance(prevX, prevY, nextX, nextY);
        if (ItselfToPrevSegScale + ItselfToNextSegScale - nextSegToPrevSegScale < 0.4
            && ((ItselfX >= prevX && ItselfX <= nextX) || (ItselfY >= prevY && ItselfY <= nextY))) {
            return true;
        }
        else if (ItselfToPrevSegScale + ItselfToNextSegScale - nextSegToPrevSegScale < 0.4
            && ((ItselfX <= prevX && ItselfX >= nextX) || (ItselfY <= prevY && ItselfY >= nextY))) {
            return true;
        }
        else {
            return false;
        }
    };
    GeometryReshapingTool.prototype.computeReshape = function (p) {
        return p; // no constraints on the points
    };
    GeometryReshapingTool.prototype.calcAngleAndLengthFromHandle = function (mousePt) {
        var tool = this;
        var h = this.handle;
        var otherH;
        var node = this.adornedShape.part;
        var adornments = node.adornments.iterator;
        var adornment;
        if (h._typ === 4) {
            return;
        }
        var shape = this.adornedShape;
        var geo = shape.geometry.copy();
        var fig = geo.figures.elt(this.handle._fig);
        adornments.each(function (a) { if (a.category === tool.name) {
            adornment = a;
        } });
        adornment.elements.each(function (e) {
            if (h._typ === 0) {
                if (node.category === DiagramConsts.elements.polygonKey) {
                    if (e._typ === 1 && e._seg === fig.segments.count - 1) {
                        otherH = e;
                    }
                }
                else {
                    if (e._typ === 1 && e._seg === 0) {
                        otherH = e;
                    }
                }
            }
            else if (h._typ === 1) {
                if (h._seg > 0) {
                    if (e._typ === 1 && e._seg === h._seg - 1) {
                        otherH = e;
                    }
                }
                else {
                    if (e._typ === 0) {
                        otherH = e;
                    }
                }
            }
        });
        // calc angle from otherH against the horizontal
        var otherHandlePt = otherH.getDocumentPoint(go.Spot.Center);
        var deltaY = mousePt.y - otherHandlePt.y;
        var deltaX = mousePt.x - otherHandlePt.x;
        var angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
        // because atan2 goes from -180 to +180 and we want it to be 0-360
        // so -90 becomes 270, etc.
        if (angle < 0) {
            angle += 360;
        }
        tool.angle = angle;
        var distanceBetween = Math.sqrt(mousePt.distanceSquared(otherHandlePt.x, otherHandlePt.y));
        tool.length = distanceBetween;
    };
    GeometryReshapingTool.prototype.isStraightLine = function () {
        var shape = this.adornedShape;
        if (!shape || !shape.part) {
            return false;
        }
        return shape.part.category === DiagramConsts.elements.straightLineKey;
    };
    GeometryReshapingTool.prototype.collapsible = function () {
        var shape = this.adornedShape;
        if (!shape || !shape.part) {
            return false;
        }
        return shape.part.category === DiagramConsts.elements.polyLineKey || shape.part.category === DiagramConsts.elements.pipeKey
            || shape.part.category === DiagramConsts.elements.polygonKey;
    };
    GeometryReshapingTool.prototype.shiftPoint = function () {
        var newPoint;
        var tool = this;
        var h = this.handle;
        var otherH;
        var node = this.adornedShape.part;
        var adornments = node.adornments.iterator;
        var adornment;
        if (h._typ === 4) {
            return;
        }
        var shape = this.adornedShape;
        var geo = shape.geometry.copy();
        var fig = geo.figures.elt(this.handle._fig);
        adornments.each(function (a) { if (a.category === tool.name) {
            adornment = a;
        } });
        adornment.elements.each(function (e) {
            if (h._typ === 0) {
                if (node.category === DiagramConsts.elements.polygonKey) {
                    if (e._typ === 1 && e._seg === fig.segments.count - 1) {
                        otherH = e;
                    }
                }
                else {
                    if (e._typ === 1 && e._seg === 0) {
                        otherH = e;
                    }
                }
            }
            else if (h._typ === 1) {
                if (h._seg > 0) {
                    if (e._typ === 1 && e._seg === h._seg - 1) {
                        otherH = e;
                    }
                }
                else {
                    if (e._typ === 0) {
                        otherH = e;
                    }
                }
            }
        });
        // calc angle from otherH against the horizontal
        var sPt = otherH.getDocumentPoint(go.Spot.Center);
        var gridSize = 1;
        // these are set in mouseMove's call to calcAngleAndLengthFromHandle()
        var angle = this.angle;
        var length = this.length;
        // snap to 90 degrees
        if (angle > 67.5 && angle < 112.5) {
            var newy = sPt.y + length;
            newy = gridSize * Math.round(newy / gridSize);
            newPoint = new go.Point(sPt.x, newy);
        }
        // snap to 180 degrees
        if (angle > 112.5 && angle < 202.5) {
            var newx = sPt.x - length;
            newx = gridSize * Math.round(newx / gridSize);
            newPoint = new go.Point(newx, sPt.y);
        }
        // snap to 270 degrees
        if (angle > 247.5 && angle < 292.5) {
            var newy = sPt.y - length;
            newy = gridSize * Math.round(newy / gridSize);
            newPoint = new go.Point(sPt.x, newy);
        }
        // snap to 360 degrees
        if (angle > 337.5 || angle < 22.5) {
            var newx = sPt.x + length;
            newx = gridSize * Math.round(newx / gridSize);
            newPoint = new go.Point(newx, sPt.y);
        }
        // snap to 45 degrees
        if (angle > 22.5 && angle < 67.5) {
            var newx = (Math.sin(.785) * length);
            newx = gridSize * Math.round(newx / gridSize) + sPt.x;
            var newy = (Math.cos(.785) * length);
            newy = gridSize * Math.round(newy / gridSize) + sPt.y;
            newPoint = new go.Point(newx, newy);
        }
        // snap to 135 degrees
        if (angle > 112.5 && angle < 157.5) {
            var newx = (Math.sin(.785) * length);
            newx = sPt.x - (gridSize * Math.round(newx / gridSize));
            var newy = (Math.cos(.785) * length);
            newy = gridSize * Math.round(newy / gridSize) + sPt.y;
            newPoint = new go.Point(newx, newy);
        }
        // snap to 225 degrees
        if (angle > 202.5 && angle < 247.5) {
            var newx = (Math.sin(.785) * length);
            newx = sPt.x - (gridSize * Math.round(newx / gridSize));
            var newy = (Math.cos(.785) * length);
            newy = sPt.y - (gridSize * Math.round(newy / gridSize));
            newPoint = new go.Point(newx, newy);
        }
        // snap to 315 degrees
        if (angle > 292.5 && angle < 337.5) {
            var newx = (Math.sin(.785) * length);
            newx = sPt.x + (gridSize * Math.round(newx / gridSize));
            var newy = (Math.cos(.785) * length);
            newy = sPt.y - (gridSize * Math.round(newy / gridSize));
            newPoint = new go.Point(newx, newy);
        }
        return newPoint;
    };
    return GeometryReshapingTool;
}(go.Tool));
export { GeometryReshapingTool };
